module.exports = __webpack_public_path__ + "static/media/S2N1-5.4d0076e0.svg";